module.exports = __webpack_public_path__ + "img/fs-shenheshibai.ae89af34.png";